import { useEffect, useState } from "react";
import styled from "styled-components";
import axios from "axios";
import Loader from "../components/Loader";
import AddStoreModal from "../components/AddStoreModal";
import FilterBar from "../components/filterBar";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useNavigate } from "react-router-dom";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Page = styled.div`
  min-height: 100vh;
  background: #f6f8fb;
  font-family: 'Segoe UI', 'Inter', Arial, sans-serif;
`;

const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 24px 18px 32px;
`;

const PageTitle = styled.h2`
  font-size: 1.6rem;
  font-weight: 700;
  color: #21325b;
  margin-bottom: 18px;
  flex:6 
`;

const TableCard = styled.div`
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 10px rgba(35,62,88,0.06);
  padding: 20px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  th, td {
    text-align: left;
    padding: 12px 16px;
    border-bottom: 1px solid #eee;
  }
  th {
    font-weight: 600;
    color: #2b3b5f;
  }
`;
const Button = styled.button`
  background: #3772FF;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 0.5rem 2rem; // shorter vertically, wider horizontally
  min-width: 80px;     // sets a reasonable minimum width
  font-weight: 600;
  font-size: 1rem;      // slightly reduced font size
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(35,62,88,0.05);
  &:hover {
    background: #245bb9;
  }
  margin : 10px 0 ;
`;
 const Row = styled.div`
  display: flex;
  gap: 22px;
  margin-bottom: 0.3rem;
`;

export default function StoresPage() {
    const userData = {
    user : JSON.parse(localStorage.getItem('user')),
    token : localStorage.getItem('access_token')
  }

  const isAdmin = userData.user.roles.role_name == "SUPER_ADMIN"
  const [isLoading, setIsLoading] = useState(false)
  const [allStores,setAllStores] = useState([])
  const [stores, setStores] = useState([]);
  const [filterText, setFilterText] = useState("");
const [filterFromDate, setFilterFromDate] = useState(null);
const [filterToDate, setFilterToDate] = useState(null);
const [sortField, setSortField] = useState(null);
const [sortOrder, setSortOrder] = useState(null);

    const [isAddStoreModalOpen, setIsAddStoreModalOpen] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editStore, setEditStore] = useState(null);
    const token = localStorage.getItem('access_token');
  const headers = { Authorization: `Bearer ${token}` };
  const navigate = useNavigate()
const hostname = window.location.hostname;
  const isInventoryDomain = hostname === 'inventory.fescafe.in' || hostname === 'localhost';
  const isRecordsDomain = hostname === 'records.fescafe.in' ;
useEffect(() => {
    if(!isAdmin)
      navigate(isRecordsDomain ?'/cashflow' : '/inventory/entries')
  }, []);
const fetchStores = async () => {
  setIsLoading(true)
      try {
        const res = await axios.get(`${BACKEND_URL}/store`,{headers});
        setStores(res.data.sort((a,b)=> a.id - b.id));
                setAllStores(res.data.sort((a,b)=> a.id - b.id));

        setIsLoading(false)
      } catch (err) {
                setIsLoading(false)

        console.log("Error fetching stores:", err.message);
      }
    };
  useEffect(() => {
    
    fetchStores();
  }, []);
useEffect(() => {
  let filtered = allStores;

  if (filterText) {
    const lowerSearch = filterText.toLowerCase();
    filtered = filtered.filter(
      (store) =>
        (store.friendly_name?.toLowerCase().includes(lowerSearch) ||
          store.city?.toLowerCase().includes(lowerSearch) ||
          store.state?.toLowerCase().includes(lowerSearch))
    );
  }

  if (filterFromDate || filterToDate) {
    filtered = filtered.filter((store) => {
      const createdAt = new Date(store.created_at);
      const from = filterFromDate ? new Date(filterFromDate) : null;
      const to = filterToDate ? new Date(filterToDate) : null;
      return (!from || createdAt >= from) && (!to || createdAt <= to);
    });
  }

  if (sortField && sortOrder) {
    filtered = [...filtered].sort((a, b) => {
      let aVal = a[sortField];
      let bVal = b[sortField];

      if (sortField === "created_at" || sortField === "updated_at") {
        aVal = new Date(aVal);
        bVal = new Date(bVal);
      } else {
        aVal = aVal || "";
        bVal = bVal || "";
      }
      if (aVal < bVal) return sortOrder === "asc" ? -1 : 1;
      if (aVal > bVal) return sortOrder === "asc" ? 1 : -1;
      return 0;
    });
  }

  setStores(filtered);
}, [allStores, filterText, filterFromDate, filterToDate, sortField, sortOrder]);

// Handlers
const handleTextFilter = (text) => setFilterText(text || "");
const handleDateFilter = (from, to) => {
  setFilterFromDate(from || null);
  setFilterToDate(to || null);
};
const handleSortChange = (field, order) => {
  setSortField(field);
  setSortOrder(order);
};
const handleResetFilters = () => {
  setFilterText("");
  setFilterFromDate(null);
  setFilterToDate(null);
  setSortField(null);
  setSortOrder(null);
};

// Export Excel
const exportToExcel = () => {
  const data = stores.map((s) => ({
    ID: s.id,
    FriendlyName: s.friendly_name,
    City: s.city,
    State: s.state,
    CreatedBy: `${s.created_by.first_name} ${s.created_by.last_name}`,
    CreatedOn: new Date(s.created_at).toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
    }),
    ModifiedBy: `${s.updated_by.first_name} ${s.updated_by.last_name}`,
    ModifiedOn: new Date(s.updated_at).toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
    }),
  }));

  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Stores");
  XLSX.writeFile(workbook, "stores_export.xlsx");
};

// Export PDF
const exportToPDF = () => {
  const doc = new jsPDF();
  const columns = [
    { header: "ID", dataKey: "id" },
    { header: "Friendly Name", dataKey: "friendlyName" },
    { header: "City", dataKey: "city" },
    { header: "State", dataKey: "state" },
    { header: "Created By", dataKey: "createdBy" },
    { header: "Created On", dataKey: "createdOn" },
    { header: "Modified By", dataKey: "modifiedBy" },
    { header: "Modified On", dataKey: "modifiedOn" },
  ];

  const rows = stores.map((s) => ({
    id: s.id,
    friendlyName: s.friendly_name,
    city: s.city,
    state: s.state,
    createdBy: `${s.created_by.first_name} ${s.created_by.last_name}`,
    createdOn: new Date(s.created_at).toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
    }),
    modifiedBy: `${s.updated_by.first_name} ${s.updated_by.last_name}`,
    modifiedOn: new Date(s.updated_at).toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
    }),
  }));

  autoTable(doc, { columns, body: rows, margin: { top: 10 }, styles: { fontSize: 8 } });
  doc.save("stores_export.pdf");
};
  const openAddModal = () => {
  setIsEditMode(false);
  setEditStore(null);
  setIsAddStoreModalOpen(true);
};

const openEditModal = (store) => {
  setIsEditMode(true);
  setEditStore(store);
  setIsAddStoreModalOpen(true);
};
// Add this function inside StoresPage component, similar to handleDeleteUser:
const handleDeleteStore = async (storeId) => {
  if (!window.confirm("Are you sure you want to delete this store?")) return;

  setIsLoading(true);
  try {
    await axios.get(`${BACKEND_URL}/store/delete/${storeId}`, { headers });
    // Refetch stores after successful deletion
    await fetchStores();
  } catch (err) {
    console.error("Error deleting store:", err.message);
  }
  setIsLoading(false);
};

  return (
    <>
      {isLoading && <Loader/>}
      <Page>
        <Container>
          <Row>
          <PageTitle>Stores</PageTitle>
         {isAdmin && <Button onClick={openAddModal}>Add Store</Button>}
          </Row>
          <Row>
            <FilterBar
  placeholder="Search stores..."
  sortFields={[
    { value: "friendly_name", label: "Friendly Name" },
    { value: "city", label: "City" },
    { value: "state", label: "State" },
    { value: "created_at", label: "Created Date" },
  ]}
  onTextFilter={handleTextFilter}
  onDateFilter={handleDateFilter}
  onSortChange={handleSortChange}
  onResetFilters={handleResetFilters}
  onExportPDF={exportToPDF}
  onExportExcel={exportToExcel}
/>

          </Row>
          <TableCard>
            <Table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Friendly Name</th>
                  <th>City</th>
                  <th>State</th>
                  <th>Created by</th>
                  <th>Created on</th>
                  <th>Last modified by</th>
                  <th>Last modified on</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {stores.map((s) => (
                  <tr key={s.id}>
                    <td>{s.id}</td>
                    <td>{s.friendly_name}</td>
                    <td>{s.city}</td>
                    <td>{s.state}</td>
                    <td>{`${s.created_by.first_name} ${s.created_by.last_name}`}</td>
                    <td>{new Date(s.created_at).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}</td> 
                    <td>{`${s.updated_by.first_name} ${s.updated_by.last_name}`}</td>
                    <td>{new Date(s.updated_at).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}</td> 
                     <td>
        <Button onClick={() => {
          openEditModal(s)
          }}
          disabled={!isAdmin}>Edit</Button></td>
          <td>
           <Button 
    onClick={() => handleDeleteStore(s.id)} 
    disabled={!isAdmin} 
    style={{ marginLeft: '8px', backgroundColor: '#d9534f' }}
  >
    Delete
  </Button>
      </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </TableCard>
           {isAddStoreModalOpen && (
  <AddStoreModal
    isOpen={isAddStoreModalOpen}
    isEdit={isEditMode}
    editStore={editStore}
    onClose={() => {
      setIsAddStoreModalOpen(false);
      setEditStore(null);
      setIsEditMode(false);
    }}
    onStoreAdded={fetchStores}
    onStoreUpdated={fetchStores}
  />
)}
        </Container>
      </Page>
    </>
  );
}
